<template lang="pug">
.container.grid-lg.py-2
  load-manager(:status="status")
    div(v-if="current")
      section.top-header
        span.text-bold.text-large \#{{ current.id }}&nbsp;
        span(v-if="current.debito_tipo") - {{ current.debito_tipo.id }}: {{ current.debito_tipo.descricao }}
      section
        .divider
        .columns
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.sub_divida",
            :value="current.sub_divida"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.parcela",
            :value="current.parcela"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.pago_em",
            :value="current.pago_em | date('DD/MM/YYYY')"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.credito_em",
            :value="current.credito_em | date('DD/MM/YYYY')"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.ano_lancamento",
            :value="current.ano_lancamento"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.valor_original",
            :value="current.valor_original | currency"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.valor_documento",
            :value="current.valor_documento | currency"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.valor_desconto",
            :value="current.valor_desconto | currency"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.valor_correcao",
            :value="current.valor_correcao | currency"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.valor_juros",
            :value="current.valor_juros | currency"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.valor_multa",
            :value="current.valor_multa | currency"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.valor_atualizacao",
            :value="current.valor_atualizacao | currency"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.codigo_agencia",
            :value="current.codigo_agencia"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.codigo_banco",
            :value="current.codigo_banco"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.codigo_barra",
            :value="current.codigo_barra"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.codigo_das",
            :value="current.codigo_das"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.codigo_gerado",
            :value="current.codigo_gerado"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.competencia",
            :value="current.competencia | date('MM/YYYY')"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.forma_pagamento",
            :value="current.forma_pagamento"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.numero_documento",
            :value="current.numero_documento"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.numero_lote",
            :value="current.numero_lote"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.obs",
            :value="current.obs"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.operacao",
            :value="current.operacao"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.pagamento_tipo",
            :value="current.pagamento_tipo"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.sistema_gerador",
            :value="current.sistema_gerador"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.tipo_debito",
            :value="current.tipo_debito"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.tipo_documento",
            :value="current.tipo_documento"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.tipo_tributo",
            :value="current | enums('pagamento.tipo_tributo')"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.smt_sincronizado_em",
            :value="current.smt_sincronizado_em | date"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.created_at",
            :value="current.created_at | date"
          )
          item-col.my-1.col-3.col-sm-6.col-xs-12(
            label="pagamento.updated_at",
            :value="current.updated_at | date"
          )
      section(v-if="current.cadastro")
        .divider
        h1.h5 {{ "pagamento.cadastro" | tModel }}
        .columns
          item-col.my-1.col-auto(
            label="cadastro.tipo",
            :value="current.cadastro | enums('cadastro.tipo')"
          )
          item-col.my-1.col-auto(
            label="cadastro.numero",
            :value="current.cadastro.numero"
          )
      section(v-if="current.contribuinte")
        .divider
        h1.h5 {{ "pagamento.contribuinte" | tModel }}
        .columns
          item-col.my-1.col-auto(
            label="contribuinte.cpf_cnpj",
            :value="current.contribuinte.cpf_cnpj | cpfCnpj"
          )
          item-col.my-1.col-auto(
            label="contribuinte.razao_social",
            :value="current.contribuinte.razao_social"
          )
      section(v-if="current.doc")
        .divider
        h1.h5 {{ "pagamento.doc" | tModel }}
        .columns
          item-col.my-1.col-4.col-sm-6.col-xs-12(
            label="doc.numero",
            :value="`${current.doc.numero}/${current.doc.ano}`"
          )
          item-col.my-1.col-4.col-sm-6.col-xs-12(
            label="doc.valor_total",
            :value="current.doc.valor_total | currency"
          )
          item-col.my-1.col-4.col-sm-6.col-xs-12(
            label="doc.created_at",
            :value="current.doc.created_at | date"
          )
          item-col.my-1.col-4.col-sm-6.col-xs-12(
            label="doc.ciencia_em",
            :value="current.doc.ciencia_em | date"
          )
          item-col.my-1.col-4.col-sm-6.col-xs-12(
            label="doc.autuado_em",
            :value="current.doc.autuado_em | date"
          )
          item-col.my-1.col-4.col-sm-6.col-xs-12(
            label="doc.debito_vence_em",
            :value="current.doc.debito_vence_em | date"
          )
        .columns(v-if="current.doc.situacao")
          item-col.my-1.col-12(
            label="doc.situacao",
            :value="current.doc.situacao.descricao"
          )
        .columns(v-if="current.doc.modelo")
          item-col.my-1.col-12(
            label="doc.modelo",
            :value="current.doc.modelo.descricao"
          )
          .column.col-12.abbr {{ current.doc.modelo.titulo }}
        .text-right
          router-link.btn.btn-link.tooltip.tooltip-left(
            :data-tooltip="'views.buttons.show.label' | translate",
            :to="{ name: 'fiscalizacao.docs.show', params: { id: current.doc_id } }"
          )
            btn-content(name="show", label="Ver Documento")
</template>

<script>
import showMixin, { vuexDefaultMapping } from "@/mixins/show"

export default {
  vuex: { pagamentos: vuexDefaultMapping },
  mixins: [showMixin],
}
</script>
